import Breadcrumbs from "components/common/Breadcrumbs";
import { Box } from "@mui/material";
import useFeatureFlag from "hooks/useFeatureFlag";

export default function Breadcrumb() {
  const { enabled: newLogisticsPageEnabled } = useFeatureFlag("new_logistics_page_enabled");
  const label = newLogisticsPageEnabled ? "Request a pickup" : "Schedule a pickup";

  return (
    <Box>
      <Breadcrumbs
        data={[{ label: "Dashboard", to: "/" }, { label: "Pickups", to: "/pickups" }, { label: label }]}
      ></Breadcrumbs>
    </Box>
  );
}
